export default __webpack_public_path__ + "static/media/013-rain.82564663.svg";